import {
    BackgroundDataAnim,
    BackgroundAnimAction,
    SET_BACKGROUND_ANIM,
    RESET_BACKGROUND_ANIM,
} from '../../Actions/Animator/background.anim.action';
import { RESET_ALL } from '../../Actions/globals.actions';

const defaultBackground: BackgroundDataAnim = {
    value: 'rgba(0,0,0,0)',
};

const backgroundAnim = (
    state: BackgroundDataAnim = defaultBackground,
    action: BackgroundAnimAction
) => {
    switch (action.type) {
        case SET_BACKGROUND_ANIM: {
            return action.payload;
        }
        case RESET_BACKGROUND_ANIM: {
            return defaultBackground;
        }
        case RESET_ALL: {
            return defaultBackground;
        }
        default:
            return state;
    }
};

export default backgroundAnim;
